import dayjs, { Dayjs } from 'dayjs'
import { appConfig } from '@/config/app.ts'

export const parseFixedFloat = (num: number | string) =>
  parseFloat(String(num)).toFixed(2)

type ParseDateTime = {
  value: string | Dayjs
  inFormat?: string
  outputFormat?: string
  isoDate?: boolean
}
export const parseDateTime = ({
  value,
  inFormat,
  outputFormat,
  isoDate
}: ParseDateTime) =>
  isoDate
    ? dayjs(value).format(outputFormat || appConfig.dateFormat)
    : dayjs(value, inFormat).format(outputFormat || appConfig.dateFormat)

export const truncateDecimals = (value: string | number) =>
  Math.ceil(parseFloat(String(value))).toFixed(2)

export const customParseFloat = (value: string | number) =>
  parseFloat(<string>value)

export const customParseInt = (value: string | number) =>
  parseInt(<string>value)
